var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPicture = function SvgPicture(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4BB9FF"
    },
    d: "M512,66v380c0,8.28-6.72,15-15,15H15c-8.28,0-15-6.72-15-15V66c0-8.28,6.72-15,15-15h482 C505.28,51,512,57.72,512,66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E98EF"
    },
    d: "M497,51H256v410h241c8.28,0,15-6.72,15-15V66C512,57.72,505.28,51,497,51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2FD6F0"
    },
    d: "M215,300v161H15c-8.28,0-15-6.72-15-15V285h200C208.28,285,215,291.72,215,300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92ECF6"
    },
    d: "M512,438.73V446c0,8.28-6.72,15-15,15H15c-8.28,0-15-6.72-15-15v-7.27L194.98,285l51.73-40.78 c5.45-4.29,13.13-4.29,18.58,0L512,438.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2FD6F0"
    },
    d: "M265.29,244.22c-2.725-2.145-6.008-3.218-9.29-3.218V461h241c8.28,0,15-6.72,15-15v-7.27 L265.29,244.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDD3E"
    },
    d: "M387,111c-35.841,0-65,29.159-65,65s29.159,65,65,65s65-29.159,65-65S422.841,111,387,111z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPicture, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/picture.568fbb66.svg";
export { ForwardRef as ReactComponent };